import axios from 'axios'
import { host, TOP, issuer } from '../constants'
import { normalizeExtension } from '../utils'

// Internal help/generic functions
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (`${name}=`)) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function buildHeaders(authorize = false, extraHeaders = {}) {
  const token = window.sessionStorage.token
  let headers = {
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache',
  }
  if (authorize && token) headers = { ...headers, Authorization: `token ${token}` }
  return { ...headers, ...extraHeaders }
}

function get(uri, params = {}, options) {
  const opt = { method: 'GET', params, headers: buildHeaders() };
  return axios.get(`${host}${uri}`, { ...opt, ...options })
    .then(response => response.data);
}

function post(uri, body = {}) {
  const options = {
    headers: buildHeaders(false, { 'X-CSRFToken': getCookie('csrftoken') }),
  };
  return axios.post(`${host}${uri}`, body, options)
    .then(response => response.data);
}

function authorizedGet({ uri, params = {}, options }) {
  const opt = {
    params,
    headers: buildHeaders(true),
  };
  return axios.get(`${host}${uri}`, { ...options, ...opt })
    .then(response => response.data);
}

function authorizedPost({ uri, params, body = {} }) {
  const options = {
    params,
    headers: buildHeaders(true, { 'X-CSRFToken': getCookie('csrftoken') }),
  };

  return axios.post(`${host}${uri}`, body, options)
    .then(response => response.data);
}

function authorizedPatch({ uri, params, body = {} }) {
  const options = {
    params,
    headers: buildHeaders(true, { 'X-CSRFToken': getCookie('csrftoken') }),
  };
  return axios.patch(`${host}${uri}`, body, options)
    .then(response => response.data);
}

function authorizedPut({ uri, params, body = {} }) {
  const options = {
    params,
    headers: buildHeaders(true, { 'X-CSRFToken': getCookie('csrftoken') }),
  };
  return axios.put(`${host}${uri}`, body, options)
    .then(response => response.data);
}

export const select = [
  "id",
  "identities",
  "displayName,"
].join() + normalizeExtension([
  "UNDPmail"
]);

export const selectUserInfo = [
  "id",
  "identities",
  "accountEnabled", 
  "department", 
  "displayName", 
  "givenName", 
  "surname",
  ""
].join() + normalizeExtension([
  "BusinessUnit",
  "DutyStation",
  "EmployeeNumber",
  "lastlogontime", // NOTE: all lowercases other
  "MiddleInitial",
  "UNDPmail",
  "UserType",
  "lastpwdchangetime",
  "pwneverexpires",
  "pwresetemail"
]);

// REST API
export function getMe() {
  return authorizedGet({ uri: 'accounts/users/me/' });
}

export function logout() {
  return authorizedPost({ uri: 'accounts/users/logout/' });
}

export function login(body) {
  return post('accounts/users/login/', body);
}

export function getSearchResult(key) {
  const params = {
    key,
    issuer,
    $top: TOP,
    $select: select
  };
  return authorizedGet({ uri: 'accounts/users/', params });
}

export function getUserInfo(userId) {
  const params = {
    $select: selectUserInfo
  };
  return authorizedGet({ uri: `accounts/users/${userId}/`, params });
}

export function updateUserInfo(userId, body) {
  return authorizedPatch({ uri: `accounts/users/${userId}/`, body });
}

export function createUser(body) {
  return authorizedPost({ uri: 'accounts/users/', body });
}

export function getLdap(uid) {
  return authorizedGet({ uri: `accounts/users/search/${uid}/` }); 
}

export function resetPassword(userId, body) {
  return authorizedPatch({ uri: `accounts/users/password-reset/${userId}/`, body });
}

export function changeToActive(userId, body) {
  return authorizedPatch({ uri: `accounts/users/set-active/${userId}/`, body });
}